import { Navigate, Route, Routes } from 'react-router-dom'
import { useAuth } from './context/auth.jsx'
import Layout from './components/Layout.jsx'
import Login from './pages/Login.jsx'
import Profile from './pages/Profile.jsx'
import PanelDashboard from './pages/PanelDashboard.jsx'
import PanelReports from './pages/PanelReports.jsx'
import PanelSources from './pages/PanelSources.jsx'
import PanelAudit from './pages/PanelAudit.jsx'
import PanelSettings from './pages/PanelSettings.jsx'

function Protected({children}){const {user,loading}=useAuth();if(loading)return null;if(!user)return <Navigate to="/login" replace/>;if(user.role!=='superadmin')return <Navigate to="/login" replace/>;return <Layout>{children}</Layout>}
function Home(){const {user,loading}=useAuth();if(loading)return null;return <Navigate to={user?.role==='superadmin'?'/superadmin':'/login'} replace/>}
export default function App(){return <Routes>
 <Route path="/login" element={<Login/>}/><Route path="/" element={<Home/>}/>
 <Route path="/superadmin" element={<Protected><PanelDashboard/></Protected>}/>
 <Route path="/domain/:id" element={<Protected><PanelDashboard/></Protected>}/>
 <Route path="/panel-offers" element={<Protected><PanelReports type="offers"/></Protected>}/>
 <Route path="/panel-users" element={<Protected><PanelReports type="users"/></Protected>}/>
 <Route path="/panel-clicks" element={<Protected><PanelReports type="clicks"/></Protected>}/>
 <Route path="/panel-conversions" element={<Protected><PanelReports type="conversions"/></Protected>}/>
 <Route path="/sources" element={<Protected><PanelSources/></Protected>}/>
 <Route path="/audit" element={<Protected><PanelAudit/></Protected>}/>
 <Route path="/panel-settings" element={<Protected><PanelSettings/></Protected>}/>
 <Route path="/profile" element={<Protected><Profile/></Protected>}/>
 <Route path="*" element={<Home/>}/>
 </Routes>}
